import type { InvoiceDataSchemaType } from '@/components/steps/InvoicingStep/invoiceDataSchema';
import SummaryStepSection from '@/components/steps/SummaryStep/SummaryStepSection';
import { getCountryLanguageNameWithFlag } from '@/configuration/lang/lang';
import { buildPhoneNumber, t } from '@/lib/utils';

export type SummaryStepContactSectionProps = {
    goToPage: (stepNumber: number) => void;
    invoicingDataState: InvoiceDataSchemaType;
    displayLocale: string | undefined;
};

export const SummaryStepContactSection = ({
    invoicingDataState,
    goToPage,
    displayLocale,
}: SummaryStepContactSectionProps) => (
    <SummaryStepSection title={t('onboarding.contactInformation')} goToFunction={() => goToPage(1)}>
        <div className='display-flex flex-row gap-20 padding-bottom-5'>
            <div className='flex-basis-80pct text-size-14'>
                <div>
                    {`${t('general.email')}: `}
                    <strong>{invoicingDataState.contact.personalEmailAddress}</strong>
                </div>
            </div>
        </div>
        <div className='padding-bottom-5'>
            {`${t('general.languageOfCommunication')}: `}
            <strong>
                {getCountryLanguageNameWithFlag(invoicingDataState.contact.languageOfCommunication, displayLocale)}
            </strong>
        </div>
        <div className='padding-bottom-5'>
            {`${t('general.contactPhoneNumber')}: `}
            <strong>
                {buildPhoneNumber(invoicingDataState.contact.countryCode, invoicingDataState.contact.phoneNumber)}
            </strong>
        </div>
    </SummaryStepSection>
);
